<template>
    <p v-html="selectionDescription">
    </p>
</template>

<script>
    import allStores from '../stores/all';

    import * as constants from '../constants';

    export default {
        mixins: [allStores],

        computed: {
            selectionDescription() {
                let description = 'Let\'s start building your bottle!';

                if (this.appStore.isEnabledStep(constants.STEP_SELECT_SPIRE)) {
                    description = `You selected <span class="font-freizeit-bold">${this.selectedProof.description[0].name}
                        ${this.selectedWhiskey.description[0].name}</span>. Great pick! Now select your spire wood.`;
                }
                if (this.appStore.isEnabledStep(constants.STEP_SELECT_INFUSION)) {
                    const spireName = this.selectedSpire.description[0].name;
                    const spireArticle = this.appStore.getArticle(spireName);
                    const infusionCopy = this.getInfusionCopy();

                    description = `You selected <span class="font-freizeit-bold">${this.selectedProof.description[0].name}
                            ${this.selectedWhiskey.description[0].name}</span> finished with ${spireArticle}
                            <span class="font-freizeit-bold">${spireName} spire</span>${infusionCopy}`;
                }

                return description;
            },

            selectedProof() {
                return this.customizerStore.viewController?.selectedAtPlacement('Proof');
            },

            selectedWhiskey() {
                return this.customizerStore.viewController?.selectedAtPlacement('Whiskey');
            },

            selectedSpire() {
                return this.customizerStore.viewController?.selectedAtPlacement('Spire');
            },

            selectedInfusion() {
                return this.customizerStore.viewController?.selectedAtPlacement('Infusion');
            },

            controllerState() {
                return this.customizerStore.viewController?.state || [];
            },

            selectedOptions() {
                return this.controllerState.filter((x) => !x.component.placeholder) || [];
            },
        },

        methods: {
            getInfusionCopy() {
                let infusionCopy = '. Now infuse it!';

                if (!this.selectedInfusion.placeholder) {
                    infusionCopy = this.selectedInfusion.code === 'InfusionNone'
                        ? '.'
                        : ` infused with <span class="font-freizeit-bold">${this.selectedInfusion.description[0].name}</span>.`;
                }

                return infusionCopy;
            },
        },
    };
</script>
